<template>
  <section
    class="bg-gradient-to-r from-green-100/70 to-green-100 relative py-16 sm:py-24"
  >
    <div class="container relative text-center">
      <div class="max-w-2xl mx-auto">
        <!-- Success Icon -->
        <div class="mb-8">
          <div
            class="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4"
          >
            <i class="fas fa-check text-white text-4xl"></i>
          </div>
          <h1 class="text-4xl font-bold text-green-700 mb-4">
            Ödeme Başarılı!
          </h1>
          <p class="text-lg text-green-600">
            Ödemeniz başarıyla işlenmiştir. Aboneliğiniz aktifleştirilmiştir.
          </p>
        </div>

        <!-- Order Information -->
        <div
          v-if="orderInfo"
          class="bg-white rounded-lg shadow-lg p-6 mb-8 text-left"
        >
          <h2 class="text-xl font-semibold mb-4 text-center">
            Sipariş Bilgileri
          </h2>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <p class="text-sm text-gray-600">Sipariş No:</p>
              <p class="font-semibold">{{ orderInfo.orderId }}</p>
            </div>
            <div v-if="subscriptionId">
              <p class="text-sm text-gray-600">Abonelik ID:</p>
              <p class="font-semibold">{{ subscriptionId }}</p>
            </div>
          </div>

          <div class="border-t pt-4">
            <p class="text-sm text-gray-600 mb-2">Toplam Tutar:</p>
            <p class="text-2xl font-bold text-green-600">
              {{ orderInfo.totalAmount?.toFixed(2) || "0.00" }} TL
            </p>
          </div>
        </div>

        <!-- Next Steps -->
        <div class="bg-blue-50 rounded-lg p-6 mb-8">
          <h3 class="text-lg font-semibold text-blue-700 mb-3">
            Sonraki Adımlar
          </h3>
          <div class="text-left space-y-2 text-blue-600">
            <p>✓ Aboneliğiniz aktifleştirilmiştir</p>
            <p>✓ E-posta adresinize onay maili gönderilmiştir</p>
            <p>✓ Panel kurulumu otomatik olarak başlatılmıştır</p>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <router-link
            :to="{ name: 'subscriptions' }"
            class="bg-green-500 text-white px-8 py-3 rounded-lg font-medium hover:bg-green-600 transition-colors"
          >
            Aboneliklerim
          </router-link>

          <router-link
            :to="{ name: 'dashboard' }"
            class="bg-gray-500 text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-600 transition-colors"
          >
            Ana Sayfa
          </router-link>
        </div>

        <!-- Support Info -->
        <div class="mt-8 text-gray-600">
          <p class="text-sm">
            Herhangi bir sorunuz varsa,
            <router-link
              :to="{ name: 'tickets' }"
              class="text-blue-500 hover:text-blue-700 underline"
            >
              destek ekibimizle iletişime
            </router-link>
            geçebilirsiniz.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const orderId = ref(route.query.orderId);
const subscriptionId = ref(route.query.subscriptionId);
const orderInfo = ref(null);

onMounted(() => {
  // Set order info from route query if available
  if (orderId.value) {
    orderInfo.value = {
      orderId: orderId.value,
      totalAmount: parseFloat(route.query.totalAmount) || null,
    };
  }

  // Auto scroll to top
  window.scrollTo({ top: 0, behavior: "smooth" });
});
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.container > div {
  animation: fadeIn 0.6s ease-out;
}
</style>
